var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-content-base"},[_c('v-layout',{attrs:{"justify-center":""}},[_c('div',{staticClass:"relative"},[_c('div',{staticClass:"lp-top-title",class:{
          'top-title-padding': !_vm.strongTitle,
          'top-title-bg': _vm.titleFontBig,
        }},[_c('span',[_vm._v(_vm._s(_vm.title))])])])]),_vm._t("subTitle")],2)}
var staticRenderFns = []

export { render, staticRenderFns }